export const SUCCESS_ICON = 'success icon';
export const ERROR_ICON = 'error icon';
